import axios from 'axios';
import { setAlert } from './alert';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Action types
export const GET_DELIVERY_PROFILES = 'GET_DELIVERY_PROFILES';
export const GET_DELIVERY_PROFILE = 'GET_DELIVERY_PROFILE';
export const CREATE_DELIVERY_PROFILE = 'CREATE_DELIVERY_PROFILE';
export const UPDATE_DELIVERY_PROFILE = 'UPDATE_DELIVERY_PROFILE';
export const DELETE_DELIVERY_PROFILE = 'DELETE_DELIVERY_PROFILE';
export const DELIVERY_PROFILE_ERROR = 'DELIVERY_PROFILE_ERROR';
export const SET_LOADING = 'SET_LOADING';

// Get all delivery profiles
export const getDeliveryProfiles = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const res = await axios.get(`${API_URL}/delivery-profiles/all`);
    
    dispatch({
      type: GET_DELIVERY_PROFILES,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: DELIVERY_PROFILE_ERROR,
      payload: { msg: err.response?.statusText, status: err.response?.status }
    });
  }
};

// Get delivery profile by ID
export const getDeliveryProfile = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const res = await axios.get(`${API_URL}/delivery-profiles/${id}`);
    
    dispatch({
      type: GET_DELIVERY_PROFILE,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: DELIVERY_PROFILE_ERROR,
      payload: { msg: err.response?.statusText, status: err.response?.status }
    });
  }
};

// Create delivery profile
export const createDeliveryProfile = (formData) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const res = await axios.post(`${API_URL}/delivery-profiles`, formData);
    
    dispatch({
      type: CREATE_DELIVERY_PROFILE,
      payload: res.data.data
    });
    
    dispatch(setAlert('Delivery profile created successfully', 'success'));
    return res.data.data;
  } catch (err) {
    const errors = err.response?.data?.errors;
    
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    } else {
      dispatch(setAlert(err.response?.data?.error || 'Error creating delivery profile', 'danger'));
    }
    
    dispatch({
      type: DELIVERY_PROFILE_ERROR,
      payload: { msg: err.response?.statusText, status: err.response?.status }
    });
    throw err;
  }
};

// Update delivery profile
export const updateDeliveryProfile = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const res = await axios.put(`${API_URL}/delivery-profiles/${id}`, formData);
    
    dispatch({
      type: UPDATE_DELIVERY_PROFILE,
      payload: res.data.data
    });
    
    dispatch(setAlert('Delivery profile updated successfully', 'success'));
    return res.data.data;
  } catch (err) {
    const errors = err.response?.data?.errors;
    
    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    } else {
      dispatch(setAlert(err.response?.data?.error || 'Error updating delivery profile', 'danger'));
    }
    
    dispatch({
      type: DELIVERY_PROFILE_ERROR,
      payload: { msg: err.response?.statusText, status: err.response?.status }
    });
    throw err;
  }
};

// Delete delivery profile
export const deleteDeliveryProfile = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    await axios.delete(`${API_URL}/delivery-profiles/${id}`);
    
    dispatch({
      type: DELETE_DELIVERY_PROFILE,
      payload: id
    });
    
    dispatch(setAlert('Delivery profile deleted successfully', 'success'));
  } catch (err) {
    dispatch({
      type: DELIVERY_PROFILE_ERROR,
      payload: { msg: err.response?.statusText, status: err.response?.status }
    });
    
    dispatch(setAlert(err.response?.data?.error || 'Error deleting delivery profile', 'danger'));
  }
};
